/* global __VERSION__ */

import { Col, Grid, withStyles } from '@kaboodle-solutions/design-system';
import React, { Fragment } from 'react';

import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import styles from './Footer.styles';

const Footer = ({ displayFooter, classes }) => (
  <Fragment>
    {displayFooter && (
      <div className={classes.footer}>
        <Grid className={classes.grid}>
          <Col sm={12} lg={6} className={classes.logoGrid}>
            <span className={classes.poweredBy}>Powered by</span>
            <div className={classes.logo} />
          </Col>
          <Col className={classes.versionGrid} sm={12} lg={6}>
            <div className={classes.version}>
              <p className={classes.versionParagraph}>{__VERSION__}</p>
            </div>
          </Col>
          <Col sm={12} lg={6} />
        </Grid>
      </div>
    )}
  </Fragment>
);

Footer.propTypes = {
  classes: PropTypes.shape({
    footer: PropTypes.string.isRequired,
    grid: PropTypes.string.isRequired,
    logo: PropTypes.string.isRequired,
    logoGrid: PropTypes.string.isRequired,
    terms: PropTypes.string.isRequired,
    termParagraph: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    poweredBy: PropTypes.string.isRequired,
    versionGrid: PropTypes.string.isRequired,
    version: PropTypes.string.isRequired,
    versionParagraph: PropTypes.string.isRequired,
  }).isRequired,
  displayFooter: PropTypes.bool,
};

Footer.defaultProps = {
  displayFooter: true,
};

export const mapStateToProps = state => ({
  displayFooter: state.ui.displayFooter,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, null),
)(Footer);
